'use client'
// lib/clevertap.js
import clevertap from 'clevertap-web-sdk';

// ✅ Set .spa before init
clevertap.spa = true; // 👈 Must be set BEFORE init()

clevertap.init('RKW-8WZ-RK7Z', 'eu1'); // ✅ Replace with your real Account ID & Region

export default clevertap;
